module.exports = __webpack_public_path__ + "static/media/adventureBeachIcon.39c9a28c.png";